var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 847.75 306.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: red;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 144.28,
    width: 61.2,
    height: 99.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.25 144.17 104.16 243.52 165.36 243.52 122.45 144.17 61.25 144.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.09,142A66.69,66.69,0,0,0,99,8.64c-1.87,0-3.72.07-5.55.23H.06v61.2h99v-.15h.11v0a5.57,5.57,0,0,1,0,11.11v0h-.11V81H.06v61.21h99Z",
    transform: "translate(0 -8.64)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.64,219.22a164.51,164.51,0,0,0,2,27.17H291.92c-1.15-3.44-2-9.73-2.58-22-4.86,10.59-17.44,25.46-46.9,25.46-33.18,0-47.48-21.45-47.48-42.9,0-31.46,24.31-45.76,67.21-45.76h27.17V146.57c0-14.3-4.29-33.46-36.89-33.46-28.89,0-33.18,15.16-36.32,26.89h-14.3c1.71-15.73,11.44-40,50.91-40,32.6,0,50.9,13.72,50.9,45.18Zm-14-45.76h-28c-31.74,0-51.48,8.29-51.48,32.89,0,18,12.87,30.31,32.89,30.31,40.9,0,46.62-27.17,46.62-58.06Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M464.09,35.61V205.2c0,13.73,0,26.88.28,41.19H450.65c-.58-3.44-.86-16.88-.86-24-7.15,17.45-23.17,27.46-48.05,27.46-37.18,0-59.49-30.32-59.49-73.22,0-44,24.31-76.64,63.21-76.64,28.6,0,40,12.29,44.33,21.45V35.61ZM357.41,176c0,39.18,20.31,60.35,44.9,60.35,37.75,0,48.05-26,48.05-64.93,0-36.89-8.87-58-45.47-58C376.57,113.4,357.41,136,357.41,176Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.85,46.19H576.2c54.91,0,92.95,38.32,92.95,98.38,0,59.77-37.18,101.82-93.24,101.82H509.85Zm15.44,185.89h48.33c52.91,0,78.94-37.17,78.94-86.65,0-44-23.45-84.94-78.94-84.94H525.29Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708.9,46.19h69.78c38.33,0,58.92,20.3,58.92,49.19,0,23.74-14.3,39.18-30.89,43.76,14.3,4,38,18,38,49.47,0,40-30,57.78-64.92,57.78H708.9Zm64.64,86.08c34.6,0,47.76-12.87,47.76-36,0-19.74-13.73-35.75-41.76-35.75H724.06v71.78Zm-49.48,99.81H780.4c26.31,0,48.33-13.15,48.33-42.61,0-25.45-16.3-42.9-56.62-42.9H724.06Z",
    transform: "translate(0 -8.64)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.72,308.42V315h-1.1V301h5c2.76,0,4.22,1.48,4.22,3.68a3.17,3.17,0,0,1-2.62,3.28c1.44.34,2.4,1.28,2.4,3.66v.54a9.33,9.33,0,0,0,.18,2.84h-1.1a9.35,9.35,0,0,1-.2-2.92v-.36c0-2.3-.68-3.26-3.36-3.26Zm0-1H19.1c2.46,0,3.6-.92,3.6-2.76s-1.12-2.7-3.3-2.7H15.72Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.86,310.12,52.08,315H51l5.14-14H57.4l5.36,14H61.58l-1.82-4.84Zm5.54-1C57.84,305,57,303,56.76,302h0c-.34,1.06-1.24,3.54-2.5,7.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.22,301h4.64c3.84,0,6.5,2.68,6.5,6.88S98.76,315,94.84,315H90.22Zm1.08,13h3.38c3.7,0,5.52-2.6,5.52-6.06,0-3.08-1.64-5.94-5.52-5.94H91.3Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.5,301v14h-1.08V301Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.9,310.12,159.12,315H158l5.14-14h1.28l5.36,14h-1.18l-1.82-4.84Zm5.54-1c-1.56-4.16-2.36-6.16-2.64-7.1h0c-.34,1.06-1.24,3.54-2.5,7.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.36,302h-4.7v-1h10.52v1h-4.72v13h-1.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.32,301v14h-1.08V301Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273,307.86c0,3.82-2,7.3-6.36,7.3-3.94,0-6.24-3.18-6.24-7.2s2.22-7.21,6.38-7.21C270.6,300.75,273,303.78,273,307.86Zm-11.44,0c0,3.22,1.78,6.26,5.14,6.26,3.62,0,5.14-3,5.14-6.28s-1.72-6.13-5.1-6.13C263.12,301.75,261.54,304.74,261.54,307.9Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301,315V301h1.6c2.18,3.36,7.3,11.18,8.18,12.7h0c-.12-2-.1-4.08-.1-6.36V301h1.1v14h-1.48c-2.08-3.24-7.28-11.38-8.28-12.92h0c.1,1.84.08,3.88.08,6.42V315Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.92,301h4.64c3.84,0,6.5,2.68,6.5,6.88s-2.6,7.12-6.52,7.12h-4.62ZM372,314h3.38c3.7,0,5.52-2.6,5.52-6.06,0-3.08-1.64-5.94-5.52-5.94H372Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M421.88,307.86c0,3.82-2,7.3-6.36,7.3-3.94,0-6.24-3.18-6.24-7.2s2.22-7.21,6.38-7.21C419.5,300.75,421.88,303.78,421.88,307.86Zm-11.44,0c0,3.22,1.78,6.26,5.14,6.26,3.62,0,5.14-3,5.14-6.28s-1.72-6.13-5.1-6.13C412,301.75,410.44,304.74,410.44,307.9Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M450,311.2c.42,1.86,1.66,3,4,3,2.56,0,3.54-1.28,3.54-2.8s-.7-2.56-3.78-3.32-4.24-1.7-4.24-3.72c0-1.84,1.34-3.57,4.34-3.57s4.38,1.89,4.56,3.59h-1.12c-.32-1.51-1.3-2.59-3.5-2.59-2,0-3.12.95-3.12,2.51s.92,2.14,3.5,2.78c3.94,1,4.52,2.56,4.52,4.24,0,2.06-1.5,3.84-4.74,3.84-3.5,0-4.78-2-5-3.92Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M494.9,308.08h-7.14V314h7.82l-.16,1h-8.74V301h8.58v1h-7.5v5.12h7.14Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M553.5,301h4.64c3.84,0,6.5,2.68,6.5,6.88S562,315,558.12,315H553.5Zm1.08,13H558c3.7,0,5.52-2.6,5.52-6.06,0-3.08-1.64-5.94-5.52-5.94h-3.38Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M594,310.12,592.22,315h-1.1l5.14-14h1.28l5.36,14h-1.18l-1.82-4.84Zm5.54-1C598,305,597.18,303,596.9,302h0c-.34,1.06-1.24,3.54-2.5,7.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M631.46,302h-4.7v-1h10.52v1h-4.72v13h-1.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M664.2,310.12,662.42,315h-1.1l5.14-14h1.28l5.36,14h-1.18l-1.82-4.84Zm5.54-1c-1.56-4.16-2.36-6.16-2.64-7.1h0c-.34,1.06-1.24,3.54-2.5,7.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M700.56,301h4.88c2.68,0,4.12,1.42,4.12,3.44a3,3,0,0,1-2.16,3.06,3.54,3.54,0,0,1,2.66,3.46c0,2.8-2.1,4-4.54,4h-5Zm4.52,6c2.42,0,3.34-.9,3.34-2.52,0-1.38-1-2.5-2.92-2.5h-3.88v5Zm-3.46,7h3.94c1.84,0,3.38-.92,3.38-3,0-1.78-1.14-3-4-3h-3.36Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.6,310.12,737.82,315h-1.1l5.14-14h1.28l5.36,14h-1.18l-1.82-4.84Zm5.54-1c-1.56-4.16-2.36-6.16-2.64-7.1h0c-.34,1.06-1.24,3.54-2.5,7.1Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M776.16,311.2c.42,1.86,1.66,3,4,3,2.56,0,3.54-1.28,3.54-2.8s-.7-2.56-3.78-3.32-4.24-1.7-4.24-3.72c0-1.84,1.34-3.57,4.34-3.57s4.38,1.89,4.56,3.59h-1.12c-.32-1.51-1.3-2.59-3.5-2.59-2,0-3.12.95-3.12,2.51s.92,2.14,3.5,2.78c3.94,1,4.52,2.56,4.52,4.24,0,2.06-1.5,3.84-4.74,3.84-3.5,0-4.78-2-5-3.92Z",
    transform: "translate(0 -8.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M821.08,308.08h-7.14V314h7.82l-.16,1h-8.74V301h8.58v1h-7.5v5.12h7.14Z",
    transform: "translate(0 -8.64)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.d000dfa7d79ae55bf8eded93fabc7218.svg";
export { ForwardRef as ReactComponent };